import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import RecruitmentFlow, {
  RecruitmentFlowFormPayload,
} from 'types/recruitment_flow'
import { mergeURL } from './lib'

const resource = 'recruitment_flows'

export const requests = {
  fetchRecruitmentFlows: () => {
    return axiosForGigbaseBiz.get<DataResponse<RecruitmentFlow[]>>(resource)
  },
  fetchIndex: async (page: number, limit: number) => {
    return await axiosForGigbaseBiz.get<DataResponse<RecruitmentFlow[]>>(
      resource,
      {
        params: {
          page,
          limit,
        },
      },
    )
  },
  fetchDetail: async (id: string) => {
    return await axiosForGigbaseBiz.get<DataResponse<RecruitmentFlow>>(
      mergeURL(resource, id.toString()),
    )
  },
  create: async (payload: RecruitmentFlowFormPayload) => {
    return await axiosForGigbaseBiz.post<DataResponse>(resource, payload)
  },
  update: async (id: string, payload: RecruitmentFlowFormPayload) => {
    return await axiosForGigbaseBiz.patch<DataResponse<RecruitmentFlow>>(
      mergeURL(resource, id.toString()),
      payload,
    )
  },
}
